<template>
    <div>
        <div class='five-nav flex-start'>
            <div v-for="(item,index) in content" >
                <img v-if="item.pic.length==0" style="width:100%;" src="https://api-xiangyou.dierqudao.com/public/images/no-pic.png" alt="" srcset="">
                    <img   v-else :src='item.pic[0].url'>
                <!-- <img :src='item.pic[0].url'> -->
                <div>{{item.title}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "NavButton",
        components: {},
        props: {
            content: {
                type: Array,
                default: [],
            },
        },

        data: function () {
            return {}
        },

        methods: {
             
        },

        filters: {}

    };
</script>

<style scoped>
    .five-nav {
        background: #fff;
    }

    .five-nav > div {
        flex: 1;
        text-align: center;
        padding: 10px 0;
    }

    .five-nav img {
        width: 60px;
        height: 60px;
    }
    .flex-start{
        display: flex;
    }
</style>